<template>
  <router-view />
</template>

<script>
import moment from "moment";

const key = "BillRecordEntryState";
const stateStorage = {
  setItem(data) {
    sessionStorage.setItem(key, JSON.stringify(data));
  },
  getItem() {
    const data = sessionStorage.getItem(key);
    return JSON.parse(data);
  },
};

export default {
  name: "BillRecordEntry",
  data() {
    return {
      outRecordList: [],
      outDetail: {},
      patientHospitalRecord: null,
      patientHospitalRecordIndex: null,
      patientHospitalDetail: null,
      status: "out",
      currentPatient: null,
      daterange: [moment().subtract(3, "months")._d, new Date()],
    };
  },
  provide() {
    return {
      BillRecordEntry: this,
    };
  },
  created() {
    const data = stateStorage.getItem();
    if (data) {
      this.outDetail = data.outDetail;
      this.patientHospitalRecord = data.patientHospitalRecord;
      this.patientHospitalRecordIndex = data.patientHospitalRecordIndex;
      this.outRecordList = data.outRecordList;
      this.status = data.status;
      this.currentPatient = data.currentPatient;
      this.daterange = data.daterange || [
        moment().subtract(1, "months")._d,
        new Date(),
      ];
    }
  },
  computed: {
    patientHospitalRecordList() {
      const data = [];
      const object = this.patientHospitalRecord.checkupDetailList;
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          const element = object[key];


          data.push({
            date: moment(key).format("YYYY年MM月DD日"),
            originDate: new Date(key),
            sum: element[0]
              ? element[0].detailsTypePrice
                : "",
            children: element,
            size: element.length,
            title: element[0]
              ? element[0].feeType
                : "",
          });
        }
      }

      return data.sort((a, b) =>
        moment(b.originDate).diff(a.originDate, "days")
      );
    },
    billingUrl() {
      if (this.status === "out") {
        if (this.outDetail) {
          return this.outDetail.billingUrl;
        }
      } else if (this.status === "in") {
        if (this.patientHospitalRecord) {
          return this.patientHospitalRecord.billingUrl;
        }
      }
    },
    checkOutId() {
      if (this.status === "out") {
        if (this.outDetail) {
          return this.outDetail.checkOutId;
        }
      } else if (this.status === "in") {
        if (this.patientHospitalRecord) {
          return this.patientHospitalRecord.checkOutId;
        }
      }
    },
  },
  methods: {
    setOutRecordList(data = []) {
      this.outRecordList = data;
      this.$router.push("/bill-outbillrecord");
      this.setStateStorage();
    },

    setOutDetail(data = null) {
      this.outDetail = data;
      this.setStateStorage();
    },

    setPatientHospitalRecord(data = null) {
      this.patientHospitalRecord = data;
      this.$router.push("/bill-hosin-billinfo");
      this.setStateStorage();
    },
    setPatientHospitalRecordDate(data = null, noPush) {
      this.patientHospitalRecordIndex = data;
      if(!noPush){
        this.$router.push("/bill-hosin-billlist");
      }
      this.setStateStorage();
    },

    setPatientHospitalDetail(data = null) {
      this.patientHospitalDetail = data;
      this.$router.push("/bill-hosin-billdetail");
      this.setStateStorage();
    },

    setStatus(value) {
      this.status = value;
      this.setStateStorage();
    },

    setCurrentPatient(data = null) {
      this.currentPatient = data;
      this.$router.push("/bill-billList");
      this.setStateStorage();
    },

    setDaterange(value) {
      this.daterange = value;
      this.setStateStorage();
    },

    downloadCurrentUrl() {
      if (this.billingUrl) {
        this.$router.push(
          `/bill-electronic-invoice-preview?billingUrl=${this.billingUrl}&checkOutId=${this.checkOutId}`
        );
      }
    },

    setStateStorage() {
      const data = {
        outRecordList: this.outRecordList,
        outDetail: this.outDetail,
        patientHospitalRecord: this.patientHospitalRecord,
        patientHospitalRecordIndex: this.patientHospitalRecordIndex,
        status: this.status,
        currentPatient: this.currentPatient,
        daterange: this.daterange,
      };

      stateStorage.setItem(data);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/billPages/layout/BillRecordEntry.vue